import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    flashMessage: String
  }

  connect() {
    this._timeoutId = null;

    this._onShow = (e) => {
      const { message } = e.detail || {};
      this.show(message || "Done", 2500);
    };

    window.addEventListener("toast:show", this._onShow);

    if (this.flashMessageValue) {
      this.show(this.flashMessageValue, 2500);
    }
  }

  disconnect() {
    window.removeEventListener("toast:show", this._onShow);
    if (this._timeoutId) clearTimeout(this._timeoutId);
  }

  show(message = "Done") {
    if (message != null) this.element.textContent = message;
    this.element.style.display = "block";

    requestAnimationFrame(() => {
      this.element.classList.add("is-visible");
    });

    if (this._timeoutId) clearTimeout(this._timeoutId);
    this._timeoutId = setTimeout(() => this.hide(), 2500);
  }

  hide() {
    this.element.classList.remove("is-visible");
    this.element.style.display = "none";
  }
}
